import { render, staticRenderFns } from "./TabelaArtigos.vue?vue&type=template&id=12eda2fc"
import script from "./TabelaArtigos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabelaArtigos.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports